/* ============================================================
   window.PNQuotes — the Discogs buyer feedback line, on a timer.

   One behaviour for both product-page modes: the quote changes on its own at
   a slow walk, and while the pointer is over it the cycle speeds up so you
   can read through every piece of feedback. Defined by whichever of
   pn-sticky.js / pn-afterhours.js parses first.

   The copy is read from the box's own `data-quotes` attribute, so whatever
   fills that attribute (hard-coded Liquid today, a Discogs sync later)
   drives both modes without touching this.
   ============================================================ */
if (!window.PNQuotes) window.PNQuotes = (function () {
  'use strict';
  var SLOW = 1000, FAST = 320, FADE = 110;   /* a change a second; a blur on hover */

  function bind(box, el) {
    if (!box || !el) return null;
    var list;
    try { list = JSON.parse(box.getAttribute('data-quotes') || '[]'); }
    catch (e) { list = []; }
    list = (list || []).filter(function (q) { return q && String(q).trim(); });
    if (list.length < 2) return null;              /* nothing to rotate through */

    /* start from whichever line the server rendered, so the first change is
       a step forward rather than a jump back to the top */
    var here = list.indexOf((el.textContent || '').trim());
    var i = here < 0 ? 0 : here;
    var timer = null;

    function show(n) {
      i = ((n % list.length) + list.length) % list.length;
      el.style.opacity = '0';
      setTimeout(function () { el.textContent = list[i]; el.style.opacity = ''; }, FADE);
    }
    function run(ms) {
      clearInterval(timer);
      timer = setInterval(function () { show(i + 1); }, ms);
    }
    box.addEventListener('mouseenter', function () { show(i + 1); run(FAST); });
    box.addEventListener('mouseleave', function () { run(SLOW); });
    /* a background tab should not burn through the list */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearInterval(timer); else run(SLOW);
    });
    run(SLOW);
    return { show: show, count: list.length };
  }
  return { bind: bind };
})();

/* ============================================================
   Paranoise — "After Hours" product page behaviours (phase 1).
   Scale-to-fit, carved-text fitting, sleeve rotate, record-sheet drift,
   play-state mirror, add to cart. The deck is mounted by pn-sticky.js /
   pn-mode.js and needs nothing from here.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('.pnah');
  if (!root) return;
  /* Canvas sizes and breakpoint are BINDING (RESPONSIVE-RULES.md).
     Two fixed-pixel compositions, each scaled as one unit. Never fluid. */
  /* WIDE_H is 745, not the design file's 960: measured on the live page, the
     composition's last pixel lands around 688 (the buy block, once the
     turntable was raised and the record column lifted), so the
     bottom 236px of the mockup's canvas is empty wood. Scaling against 960
     made the whole page render ~25% smaller than it needed to and left big
     margins at the sides. Nothing inside the design moved - only the dead
     space below it was trimmed. */
  /* Section sizes are CONSTANT inside a band; only the space between them
     moves (Rue, 2026-09-07). So the band's floor is arithmetic, not taste:
     the widest row in the wide design is
        deck 697 + min gap 24 + record column 440 + side padding 2x24 = 1209,
     and below that the record would start crossing the turntable. 1220 gives
     it a few px of air. That is the "elements get too close and the design
     breaks" threshold, measured rather than guessed. */
  /* WIDE_FLOOR is arithmetic: the widest row in the wide design is
     deck 697 + min gap 24 + record column 440 + padding 2x24 = 1209 canvas px.
     Below that the record starts crossing the turntable - the point Rue calls
     "they will go into one another and the design will break". */
  /* WIDE_FLOOR is arithmetic, from the design's own fixed parts:
       left column 688 + min gap 24 + record column 440 + min padding 2x24 = 1200.
     At that point the record is as close to the tracklist as it can get. */
  var WIDE_W = 1376, WIDE_H = 695, CMP_W = 900, CMP_H = 980;
  var WIDE_FLOOR, CMP_FLOOR;   /* computed from the ratio floor, just below */
  var LEFT_W = 688, RIGHT_W = 440, GAP_MAX = 48, RMAR_MAX = 120;
  var PAD_MAX = 40, INDENT_MAX = 56;
  /* the design's own chain: 40 + 688 + 48 + 440 + 120 + 40 = 1376 */
  /* width(r) = 2*40r + (551+137r) + 48r + (360+80r) + 120r = 911 + 465r */
  var RATIO_C = 911, RATIO_M = 465;
  /* how far the spaces may close before the design is simply too tight */
  var R_MIN = 0.35;
  /* midsize: 2x30 + 478 + 40 + 320 + 8 = 906 */
  var CMP_LEFT = 478, CMP_RIGHT = 320, CMP_MAX = 1.30;
  var CMP_FIXED = CMP_LEFT + CMP_RIGHT;                        /* 798 */
  var CMP_SPACE = 2 * 30 + 40 + 8;                             /* 108 */
  /* slogan wheel: radius, and how far its rim reaches into the canvas at r=1 */
  var CLOCK_R = 780, CLOCK_IN = 130;
  WIDE_FLOOR = RATIO_C + RATIO_M * R_MIN;       /* 1074 */
  CMP_FLOOR  = CMP_FIXED + CMP_SPACE * R_MIN;   /* 836  */
  /* how far the wide design may shrink before it gives up and hands over to
     midsize - "shrinking in size just a little, not so much" */
  var SHRINK_MIN = 0.86;
  /* Three modes (Rue, 2026-09-07): the fullscreen design down to a threshold,
     then a rearranged middle design down to a threshold, then the mobile
     column - "it shrinks in size instead of rearranging".

       >= 1100   WIDE     the approved fullscreen page, untouched
       780-1100  COMPACT  the middle design, scale 0.87 -> 1.22
       < 780     MOBILE   fluid column, no scaling at all

     780, not the 700 of MOBILE-RULES.md: the middle canvas is 900px wide and
     is drawn at width/900, so it was still shrinking to 0.78 at the bottom of
     its band - 12.5px body text rendering at 9.7px, which is the "looks so
     bad" case. Handing over at 780 floors the middle design at 0.87 and lets
     the mobile column, which never scales, take everything below. */
  var MOB = 780;
  function isMobile() { return root.getAttribute('data-ah-layout') === 'mobile'; }
  function clamp01(v) { return v < 0 ? 0 : (v > 1 ? 1 : v); }
  function lerp2(t, a, b) { return (a + (b - a) * t).toFixed(1); }

  var active = function () { return (document.documentElement.getAttribute('data-pn-mode') || 'sticky') === 'afterhours'; };

  /* ---------- layout: two canvases, scaled by WIDTH ONLY ----------
     Height must never enter the scale formula — that shrinks the whole
     composition into unreadable text on a short window. Short windows
     scroll instead. The WIDE scale is uncapped so a big monitor fills
     the width exactly like the mockup. */
  var wrap  = root.querySelector('.pnah-main');
  var stage = root.querySelector('.pnah-stage');
  var curScale = 0, curCompact = null, curCanvasW = 0, curLayout = null, curSq = -1;

  /* the nodes that change parent between the two compositions */
  var elBody = root.querySelector('.pnah-body');
  var elLeft = root.querySelector('.pnah-left');
  var elRight= root.querySelector('.pnah-right');
  var elCols = root.querySelector('.pnah-cols');
  var elDeck = root.querySelector('.pnah-deckzone');
  var elDesc = root.querySelector('.pnah-desc');
  var elBuy  = root.querySelector('.pnah-buy');
  var elArt  = root.querySelector('.pnah-carve--artist');
  var elTracks = root.querySelector('.pnah-tracks');
  var elSheet  = root.querySelector('.pnah-sheet');
  var elQuote  = root.querySelector('.pnah-quote');
  var elMascot = root.querySelector('.pnah-mascot');
  var elRule   = root.querySelector('.pnah-rule');
  var crow = null, ccol = null, mclip = null;

  /* Every node that changes parent between the three compositions, with
     the parent and next sibling it had in the markup. Restoring from that
     record is the only reliable way back: hand-written inverse moves have
     to be kept in step with three layouts and silently rot. Restored in
     REVERSE document order so each anchor sibling is already back in place
     by the time the node before it is inserted. */
  var MOVERS = [elDesc, elCols, elTracks, elSheet, elDeck, elQuote, elRight, elMascot, elBuy]
    .filter(Boolean)
    .map(function (n) { return { n: n, p: n.parentNode, s: n.nextSibling }; });
  function restoreHome() {
    for (var i = MOVERS.length - 1; i >= 0; i--) {
      var h = MOVERS[i];
      if (!h.p) continue;
      if (h.s && h.s.parentNode === h.p) h.p.insertBefore(h.n, h.s);
      else h.p.appendChild(h.n);
    }
  }

  function relayout(mode) {
    if (!stage || !elBody || !elLeft || !elRight || !elCols || !elDeck || !elDesc || !elBuy) return;
    restoreHome();                           /* always rebuild from the markup */
    if (mclip && mclip.parentNode) mclip.parentNode.removeChild(mclip);
    if (crow && crow.parentNode) crow.parentNode.removeChild(crow);

    if (mode === 'compact') {
      if (!crow) {
        crow = document.createElement('div'); crow.className = 'pnah-crow';
        ccol = document.createElement('div'); ccol.className = 'pnah-ccol';
        crow.appendChild(ccol);
      }
      /* Rearranged on Rue's instruction (2026-09-07): the price and ADD TO CART
         go under the record image, and the tracklist and record sheet go under
         the description, so the row reads

             [ description + tracklist | sheet ]   [ record + price + cart ]

         and the turntable spans the full width beneath it. The buy block's
         home in the markup is already .pnah-right, so restoreHome() has put it
         there - it simply is not moved out any more. */
      stage.insertBefore(crow, elBody);
      ccol.appendChild(elDesc);
      ccol.appendChild(elCols);              /* tracklist | sheet, under the description */
      if (elQuote) ccol.appendChild(elQuote);  /* buyer feedback under the sheet, left */
      crow.appendChild(elRight);             /* record, with the buy block below it */
      stage.insertBefore(elDeck, elBody);    /* turntable last, full width */

    } else if (mode === 'mobile') {
      /* One column, in the order MOBILE-RULES.md sets out. The nodes are the
         same ones the wide canvas uses, so every field, link and handler on
         the page is carried over rather than duplicated for a second layout. */
      if (elRule) stage.appendChild(elRule);
      stage.appendChild(elDesc);
      stage.appendChild(elRight);            /* sleeve + mascot + SIMILAR */
      if (elTracks) stage.appendChild(elTracks);
      if (elSheet)  stage.appendChild(elSheet);
      stage.appendChild(elDeck);
      if (elQuote)  stage.appendChild(elQuote);   /* out of the deck zone */
      /* The mascot moves into a clip window ABOVE the sleeve so that at rest
         it is fully off-screen instead of peeping over the record's corner. */
      if (elMascot) {
        if (!mclip) { mclip = document.createElement('div'); mclip.className = 'pnah-mclip'; }
        mclip.setAttribute('data-pn-sim', 'mascot-clip');   /* so a tap on it is "inside" */
        elRight.insertBefore(mclip, elRight.firstChild);
        mclip.appendChild(elMascot);
      }
      /* the buy block leaves the flow entirely and becomes the fixed bottom bar */
      root.appendChild(elBuy);
    }
    /* The tap controller leaves an inline transition and offset on the three
       window tracks. The drift writes a transform every frame, so a stale
       .38s transition would make it lag; clear both on the way out. */
    if (mode !== 'mobile') {
      ['.pnah-mtrack', '.pnah-tl-track', '.pnah-sheet-track'].forEach(function (sel) {
        var t = root.querySelector(sel);
        if (t) { t.style.transition = ''; t.style.transform = ''; }
      });
      /* the SIMILAR columns scroll natively on mobile and by transform on the
         two canvases; hand them back with scrollTop zeroed */
      ['.pnah-sim-col--a', '.pnah-sim-col--b'].forEach(function (sel) {
        var w = root.querySelector(sel);
        if (w) w.scrollTop = 0;
      });
    }
    root.setAttribute('data-ah-layout', mode);
    /* the carved artist box is a different size in each composition, and
       its glyph width changes with the font-size, so re-fit after the swap.
       Mobile sets its own box in fitMobile() - two lines, its own size - so
       it must not be given the single-line wide/compact box here. */
    if (elArt && mode !== 'mobile') {
      var isCmp = (mode === 'compact');
      var h = isCmp ? 52 : 58;
      elArt.setAttribute('height', String(h));
      var vb = (elArt.getAttribute('viewBox') || '0 0 720 58').split(/\s+/);
      elArt.setAttribute('viewBox', '0 0 ' + (vb[2] || 720) + ' ' + h);
      /* Chrome does not reliably re-lay-out SVG text when only an ancestor
         attribute changes its CSS font-size: getComputedTextLength keeps
         handing back the old metrics, the box is fitted to the wrong width
         and the carved name paints clipped ("ECHONOMIS"). Writing the size
         on the element itself forces the invalidation. */
      var at = elArt.querySelector('text');
      if (at) at.style.fontSize = (isCmp ? 46 : 52) + 'px';
    }
    /* and re-fit over the next few frames: the first pass can still read
       metrics from before the swap */
    fitAll();
    requestAnimationFrame(fitAll);
    [60, 250].forEach(function (ms) { setTimeout(fitAll, ms); });
    /* the deck canvas changed size with the composition */
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }

  /* The canvas is the design file's own 1376x960, never stretched: widening
     the boxes while the type stayed put is what made the page read as
     "spaced out". One uniform scale for the whole composition, as large as
     will fit on screen, so the design stays exactly as Claude Design drew it
     and everything grows together. */
  function headerBottom() {
    var h = document.querySelector('sticky-header, .header-wrapper, #shopify-section-header');
    var b = h ? h.getBoundingClientRect().bottom : 0;
    return b > 0 ? b : 90;
  }
  function measure() {
    if (!wrap || !active()) return;
    var w = wrap.clientWidth || wrap.getBoundingClientRect().width || window.innerWidth;
    if (!w) return;
    /* Mobile takes over when midsize can no longer hold its own floor even at
       the smallest scale it is allowed - the same "the design breaks here"
       test the other two hand-overs use, so all three thresholds move together
       with the visitor's screen instead of being three fixed numbers. */
    var mLock = Math.min(((window.screen && screen.availWidth) || w) / CMP_W, CMP_MAX);
    var mobFloor = (isFinite(mLock) && mLock > 0) ? (CMP_FLOOR * mLock * SHRINK_MIN) : MOB;
    if (w < Math.max(MOB, mobFloor)) {
      /* No scale, no canvas: the column is fluid and the page scrolls. */
      if (curLayout !== 'mobile') { curLayout = 'mobile'; curCompact = null; relayout('mobile'); buildMobile(); }
      root.style.setProperty('--ah-scale', '1');
      root.style.setProperty('--ah-canvas-w', '100%');
      root.style.setProperty('--ah-canvas-h', 'auto');
      root.style.setProperty('--ah-k', '1');
      root.style.setProperty('--ah-kf', '1');
      root.style.setProperty('--ah-sq', '1');   /* nothing squeezes on mobile */
      curScale = 1; curCanvasW = 0; curSq = 1;
      return;
    }
    /* ---- THE RULE (Rue, 2026-09-07) ------------------------------------
       "each design mode will have to have their sections moved closer or
       further away from each other as the browser size changes, instead of
       having them change in size... the sections must start getting closer to
       each other while also shrinking in size just a little, not so much...
       until a point where it is not possible to get closer anymore and then it
       switches."

       Each band therefore does three things in order as the window narrows:
         1. close the space OUTSIDE the columns (the record's right margin),
         2. close the space BETWEEN them (the middle gap),
         3. only then shrink, and only by a little (SHRINK_MIN),
       and hands over when even that is spent. The columns themselves are fixed
       widths so the space really does close - as flexible columns they simply
       swallowed it and the middle got emptier instead. */
    /* Which band we are in is decided in CANVAS units, because the canvas is
       scaled: on a big monitor everything is drawn 1.35x, so the design runs
       out of room at a much wider WINDOW than on a laptop. Same design floor,
       different pixel threshold per screen - which is the point. */
    var probeMax = Math.max(w, (window.screen && screen.availWidth) || 0);
    var probeH = window.innerHeight - headerBottom() - 12;
    var probeLock = Math.min(probeMax / WIDE_W, probeH / WIDE_H);
    /* wide survives while the floor still fits at the smallest scale we allow */
    var compact = !(isFinite(probeLock) && probeLock > 0)
      ? (w < WIDE_FLOOR)
      : (w < WIDE_FLOOR * probeLock * SHRINK_MIN);
    var canvasW, canvasH, scale, sq;
    if (compact) {
      /* Same model as wide: the scale is locked (capped at CMP_MAX so midsize
         never out-grows the design it took over from), the window buys canvas
         units, and the pool between the two fixed columns closes.
         CMP_MAX 1.30 is chosen so the record is ~390px at the hand-over -
         where the wide design leaves off - instead of dropping to 300. */
      var cLock = Math.min(((window.screen && screen.availWidth) || w) / CMP_W, CMP_MAX);
      scale = cLock;
      var cUnits = w / scale;
      if (cUnits < CMP_FLOOR) {
        scale = Math.max(cLock * SHRINK_MIN, w / CMP_FLOOR);
        cUnits = w / scale;
      }
      canvasW = Math.min(CMP_W, cUnits); canvasH = CMP_H;
      var cr = Math.max(R_MIN, Math.min(1, (canvasW - CMP_FIXED) / CMP_SPACE));
      sq = cr;
      root.style.setProperty('--ah-pad',   (30 * cr).toFixed(1) + 'px');
      root.style.setProperty('--ah-cgap',  (40 * cr).toFixed(1) + 'px');
      root.style.setProperty('--ah-crmar', (8  * cr).toFixed(1) + 'px');
    } else {
      /* WIDE.

         THE REFERENCE IS THE LIVE PAGE AT THE VISITOR'S MAXIMUM BROWSER SIZE
         (Rue, 2026-09-07): "open the current live theme and go on product page,
         I want that to be the maximum size of any browser, use that as your
         reference size... and then as they make their browser size smaller
         horizontally then the design elements must get closer to each other
         instead of getting smaller in size."

         So the scale comes from the SCREEN, not the window, and is then held:
         maximise the window and it is live's own formula on live's own numbers,
         so the page is identical to the live theme. Narrow the window and the
         scale does not move - every section keeps the size it had - and the
         window simply buys fewer canvas units, which closes the gaps.

           scale      = min(screenWidth/1376, availH/695)   <- locked
           canvasUnits= windowWidth / scale                 <- shrinks as you narrow
           canvasW    = min(1376, canvasUnits)              <- 1376 when maximised

         At canvasW 1376 every spacing is the design's own number, so the
         approved composition is reproduced exactly. */
      var maxW = Math.max(w, (window.screen && screen.availWidth) || 0);
      var availH = window.innerHeight - headerBottom() - 12;
      var lock = Math.min(maxW / WIDE_W, availH / WIDE_H);   /* live's own scale, held */
      if (!isFinite(lock) || lock <= 0) return;
      canvasH = WIDE_H; sq = 1;

      /* Canvas units the window can pay for. Below the floor we do NOT jump
         straight to midsize - the sections are allowed to shrink a little
         first (Rue: "getting closer to each other while also shrinking in size
         just a little"), down to SHRINK_MIN of the locked scale. Only when
         that is spent as well does the design actually break. */
      scale = lock;
      var units = w / scale;
      if (units < WIDE_FLOOR) {
        scale = Math.max(lock * SHRINK_MIN, w / WIDE_FLOOR);
        units = w / scale;
      }
      canvasW = Math.min(WIDE_W, units);

      /* ONE RATIO (Rue, 2026-09-07). Every horizontal space is the design's
         number x r, AND the two columns narrow with it, because a column wider
         than its content is itself dead space:

           - the left column is 688 only because the TURNTABLE'S BOX is 697.
             The description is 548 and the tracklist pair 560, so ~90px beside
             them never moved however far the window came in. That was Rue's
             "the empty space on the left side of the record image does not
             change at all". The box narrows now - and the turntable inside it
             barely changes, because its canvas is centred and mostly
             transparent, so it simply overhangs a little further.
           - the record column is 440 around a 330 sleeve, another 55px a side.

         At r = 1 every number is the design's own, so the approved page is
         reproduced exactly:
             40 + 688 + 48 + 440 + 120 + 40 = 1376, deck 697 (overhangs by 9).
         Total width as a function of r is 911 + 465r, so r inverts cleanly. */
      var r = Math.max(R_MIN, Math.min(1, (canvasW - RATIO_C) / RATIO_M));
      var leftW  = 551 + 137 * r;      /* 688 -> 599 */
      var rightW = 360 + 80  * r;      /* 440 -> 388 */
      root.style.setProperty('--ah-pad',    (PAD_MAX  * r).toFixed(1) + 'px');
      root.style.setProperty('--ah-indent', (INDENT_MAX * r).toFixed(1) + 'px');
      root.style.setProperty('--ah-gap',    (GAP_MAX  * r).toFixed(1) + 'px');
      root.style.setProperty('--ah-rmar',   (RMAR_MAX * r).toFixed(1) + 'px');
      root.style.setProperty('--ah-leftw',  leftW.toFixed(1) + 'px');
      root.style.setProperty('--ah-rightw', rightW.toFixed(1) + 'px');
      /* the deck keeps its 9px overhang of the column, exactly as at design */
      root.style.setProperty('--ah-deckw',  (leftW + 9).toFixed(1) + 'px');
      /* The slogan wheel rides in the strip right of the record, so it
         contracts too - and fades, because a blade's slogan sits at the rim and
         READS INWARD, crossing the sleeve long before the rim would. */
      root.style.setProperty('--ah-clock-out',
        (CLOCK_R - Math.min(CLOCK_IN, (PAD_MAX + RMAR_MAX) * r - 8)).toFixed(1) + 'px');
      root.style.setProperty('--ah-clock-op', clamp01((r - 0.55) / 0.35).toFixed(2));
    }
    if (!isFinite(scale) || scale <= 0) return;
    var want = compact ? 'compact' : 'wide';
    if (Math.abs(scale - curScale) <= 0.003 && want === curLayout && canvasW === curCanvasW
        && Math.abs(sq - curSq) <= 0.004) return;
    curScale = scale; curCanvasW = canvasW; curSq = sq;
    if (want !== curLayout) { curLayout = want; curCompact = compact; relayout(want); }
    root.style.setProperty('--ah-sq', sq.toFixed(4));
    /* "footer has to stay at the bottom and can only be reached by scrolling
       down" - so the product section is never shorter than the screen. The
       Sticky panel already does this with its own --pnsn-head; After Hours had
       nothing, which is why the footer kept appearing under the design. */
    root.style.setProperty('--ah-head', Math.round(headerBottom()) + 'px');
    root.style.setProperty('--ah-scale', scale.toFixed(4));
    root.style.setProperty('--ah-canvas-w', canvasW + 'px');
    root.style.setProperty('--ah-canvas-h', canvasH + 'px');
    root.style.setProperty('--ah-k', '1');    /* nothing is stretched any more */
    root.style.setProperty('--ah-kf', '1');
  }
  measure();
  window.addEventListener('resize', measure);
  window.addEventListener('pn:mode', function () { setTimeout(function () { measure(); fitAll(); }, 30); });
  requestAnimationFrame(measure);
  [60, 400].forEach(function (ms) { setTimeout(measure, ms); });
  if (window.ResizeObserver && wrap) { try { new ResizeObserver(measure).observe(wrap); } catch (e) {} }

  /* ---------- carved SVG text: size the box to the glyphs ---------- */
  /* A long name is SET SMALLER, not squashed.

     This used to hit `lengthAdjust="spacingAndGlyphs"`, which does not scale
     the type — it crushes each glyph horizontally while leaving its height
     alone. On a name like "Timo van Luijk & Kris Vanderstraeten" the letters
     came out visibly narrow and distorted, as if the font had been condensed.
     Stepping the font-size down keeps the letterforms true; the squeeze is
     kept only as a last resort for a name that will not fit even at minFs,
     where a little compression beats overflowing the canvas. */
  function fitSvg(svg, maxW, baseFs, minFs) {
    var t = svg.querySelector('text'); if (!t) return;
    t.removeAttribute('textLength'); t.removeAttribute('lengthAdjust');

    var len;
    if (maxW && baseFs) {
      var fs = baseFs;
      t.style.fontSize = fs + 'px';
      try { len = t.getComputedTextLength(); } catch (e) { return; }
      while (len > maxW && fs > minFs) {
        fs = Math.max(minFs, fs - 1);
        t.style.fontSize = fs + 'px';
        try { len = t.getComputedTextLength(); } catch (e) { break; }
      }
    }
    try { len = t.getComputedTextLength(); } catch (e) { return; }
    if (!len) return;

    var vb = (svg.getAttribute('viewBox') || '0 0 0 0').split(/\s+/).map(Number);
    var h = vb[3] || svg.height.baseVal.value;
    if (maxW && len > maxW) {                     /* still over at minFs: compress */
      t.setAttribute('textLength', String(maxW - 4)); t.setAttribute('lengthAdjust', 'spacingAndGlyphs');
      svg.setAttribute('width', String(maxW)); svg.setAttribute('viewBox', '0 0 ' + maxW + ' ' + h);
    } else {                                      /* otherwise the box follows the text */
      var w = Math.ceil(len + 6);
      svg.setAttribute('width', String(w)); svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    }
  }
  function fitAll() {
    var lay = root.getAttribute('data-ah-layout');
    if (lay === 'mobile') { fitMobile(); return; }
    var compact = lay === 'compact';
    var a = root.querySelector('.pnah-carve--artist');
    /* base sizes mirror .pnah-carve--artist text in the stylesheet (57 wide,
       46 compact); the floors are where the name stops shrinking */
    if (a) fitSvg(a, compact ? 640 : 720, compact ? 46 : 57, compact ? 26 : 32);
    var ti = root.querySelector('.pnah-carve--title'); if (ti) fitSvg(ti, 0);
    var p = root.querySelector('.pnah-carve--price'); if (p) { fitSvg(p, 0); strikePrice(p); }
  }

  /* Sold out: a thin orange rule struck across the price, on a slant rather
     than flat. Drawn as a line INSIDE the price SVG, so it spans exactly the
     numerals, stops before CAD, slants by the same proportion whatever the
     price is wide, and is re-laid whenever the carved box is re-measured.
     (A CSS background can only paint a horizontal band, which is what made
     the first version flat.) */
  function strikePrice(svg) {
    var sold = root.querySelector('.pnah-stock--sold');
    var line = svg.querySelector('.pnah-strike');
    if (!sold) { if (line && line.parentNode) line.parentNode.removeChild(line); return; }
    var vb = (svg.getAttribute('viewBox') || '0 0 180 52').split(/\s+/).map(Number);
    var w = vb[2] || 180, h = vb[3] || 52;
    if (!line) {
      line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('class', 'pnah-strike');
      svg.appendChild(line);
    }
    /* rises from lower-left to upper-right, overhanging each end slightly;
       the SVG is overflow:visible, so the overhang shows */
    line.setAttribute('x1', '-3');            line.setAttribute('y1', (h * 0.82).toFixed(1));
    line.setAttribute('x2', String(w + 3));   line.setAttribute('y2', (h * 0.32).toFixed(1));
  }
  /* Measure only once Bugrino is really in: font-display:swap means the
     first measurement can see the fallback face, which is narrower, and the
     carved box then ends up too small and the genre line crowds into it. */
  fitAll();
  if (document.fonts && document.fonts.load) {
    Promise.all([
      document.fonts.load('900 52px Bugrino'),
      document.fonts.load('700 22px Bugrino'),
      document.fonts.load('900 48px Bugrino')
    ]).then(fitAll, fitAll);
  }
  [300, 1200, 3000].forEach(function (ms) { setTimeout(fitAll, ms); });

  /* ---------- sleeve: click rotates 180, always the same direction ---------- */
  (function () {
    var sl = root.querySelector('.pnah-sleeve'), flip = root.querySelector('.pnah-flip');
    if (!sl || !flip) return;
    var rot = 0;
    function turn() { rot += 180; flip.style.transform = 'rotateY(' + rot + 'deg)'; sl.setAttribute('data-rot', String(rot)); }
    sl.addEventListener('click', turn);
    /* stopPropagation: pn-turntable.js has a document-level keydown that
       toggles playback on Space while the deck is mounted */
    sl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); turn(); } });
  })();

  /* ---------- Discogs buyer feedback: same rotation as the Sticky page ---------- */
  window.PNQuotes.bind(root.querySelector('.pnah-quote'), root.querySelector('.pnah-quote-text'));

  /* ---------- slogan windmill ----------
     The Paranoise slogans ride the blades of a windmill whose hub sits ON the
     right edge of the window, so exactly half the wheel is on screen: a
     slogan swings in from the edge, sweeps across, and disappears back out.
     Each slogan's text IS a blade - anchored on the hub and reading inward,
     so it is the right way up exactly when it is fully in view.

     Copy is the 2x3 sticker sheet (PARANOISE_2x3_SLOGAN_STICKERS.pdf), all
     of it. The wheel hangs off .pnah-main rather than the stage, because the
     hub has to land on the window's edge, not the design canvas's edge - the
     canvas is centred, and on a wide screen its edge is well inside the
     window. It is scaled by hand with --ah-scale so it grows with the design.

     Rotation is driven here rather than by a CSS animation so the wheel can
     be paused and scrubbed with the mouse wheel while the pointer is over
     it. ---------- */
  (function () {
    var host = root.querySelector('.pnah-stage');      /* scales with the design */
    var pane = root.querySelector('.pnah-main');       /* where the pointer is tracked */
    if (!host || !pane) return;

    var SLOGANS = [
      'Dig. Then Spin.', 'Dig What You Spin.', 'Spin What You Dig.',
      'Dig It. Spin It.', 'You Dig It. You Spin It.', 'Dig Your Sound.',
      'Find Your Spin.', 'Dig Deep. Spin Free.', 'Dig Before You Spin.',
      'What You Dig Is What You Spin.', 'Dig Deeper.', 'Always Digging.',
      'Born to Dig.', 'Dig Responsibly.', 'Dig With Purpose.', 'Dig Beyond.',
      'Dig the Noise.', 'Dig Strange.', 'Dig First.', 'Found While Digging.',
      'Do You Even Dig?', 'Dig Happens.', 'Still Digging?', 'Never Stop Digging.',
      'Dig Now. Think Later.', 'One More Crate.', 'Just One More Record.',
      'You Had Me at Vinyl.', 'Digging Is the Problem.', 'Vinyl Is the Solution.',
      'Keep Digging Until Closing Time.', 'No Digging, No Glory.',
      'Keep Digging.', 'Do You Dig?', 'Deep Diggers.'
    ];

    var R = 780;   /* set from the CSS below, once the wheel is in the DOM */
    /* Two blades per slogan, so the gap between them halves. A slogan and its
       twin sit exactly 180 degrees apart - one is always off the page while
       the other is in view, so the same words never appear twice at once. */
    var n = SLOGANS.length * 2;
    var period = 150;            /* seconds for a full turn; a big wheel is slow */

    var clock = document.createElement('div');
    clock.className = 'pnah-clock';
    var face = document.createElement('div');
    face.className = 'pnah-clock-face';
    var ring = document.createElement('div');
    ring.className = 'pnah-clock-ring';

    for (var i = 0; i < n; i++) {
      var text = SLOGANS[i % SLOGANS.length];
      var blade = document.createElement('span');
      blade.className = 'pnah-clock-hand';
      /* max four words to a line; the rest drops to a second row */
      var words = text.split(/\s+/);
      var rows = words.length > 4 ? [words.slice(0, 4).join(' '), words.slice(4).join(' ')]
                                  : [text];
      rows.forEach(function (r) {
        var line = document.createElement('span');
        line.className = 'pnah-clock-line';
        line.textContent = r;
        blade.appendChild(line);
      });
      blade.style.transform = 'rotate(' + ((360 / n) * i) + 'deg)';
      ring.appendChild(blade);
    }
    face.appendChild(ring);
    clock.appendChild(face);
    host.appendChild(clock);
    /* --ah-clock-r is declared on .pnah-clock, and a custom property is only
       visible on the element that declares it or its descendants - reading it
       off documentElement would silently return nothing. Read it here, now
       that the wheel is in the document, so CSS stays the single source. */
    var declared = parseFloat(getComputedStyle(clock).getPropertyValue('--ah-clock-r'));
    if (declared > 0) R = declared;

    /* ---- turn it ---- */
    var angle = 0, hover = false, raf = null, last = 0;
    function step(ts) {
      if (!last) last = ts;
      var dt = Math.min((ts - last) / 1000, 0.1);
      last = ts;
      if (!hover) angle -= (360 / period) * dt;      /* anticlockwise */
      ring.style.transform = 'rotate(' + angle.toFixed(3) + 'deg)';
      raf = requestAnimationFrame(step);
    }
    function run() { if (!raf) { last = 0; raf = requestAnimationFrame(step); } }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    /* The wheel must not swallow clicks on the record or the cart underneath
       it, so the face stays pointer-transparent and the pointer is tested
       against the ring's own geometry instead. */
    function overWheel(x, y) {
      var f = face.getBoundingClientRect();
      if (!f.width) return false;
      var cx = f.left + f.width / 2, cy = f.top + f.height / 2;
      var dx = x - cx, dy = y - cy;
      var d = Math.sqrt(dx * dx + dy * dy);
      var unit = f.width / (2 * R);                  /* device px per canvas unit */
      return d <= (R + 10) * unit && d >= (R - 260) * unit;
    }
    pane.addEventListener('mousemove', function (e) { hover = overWheel(e.clientX, e.clientY); });
    pane.addEventListener('mouseleave', function () { hover = false; });
    pane.addEventListener('wheel', function (e) {
      /* MOBILE-RULES.md 12: the deck is LOCKED on mobile - no orbit, drag or
         scratch. It only shows playback. */
      if (isMobile()) return;
      if (!active() || !overWheel(e.clientX, e.clientY)) return;
      e.preventDefault();                            /* scrub instead of scrolling */
      angle -= e.deltaY * 0.06;
      ring.style.transform = 'rotate(' + angle.toFixed(3) + 'deg)';
    }, { passive: false });

    if (active()) run();
    window.addEventListener('pn:mode', function () { if (active()) run(); else stop(); });
  })();

  /* ---------- tracklist: the record sheet's drift, running the other way ----------
       The sheet scrolls its rows upward; this scrolls them downward, on the
       same loop. A seamless loop needs a second copy of the rows to wrap
       into, so the list is duplicated - and because the copies are clones,
       they carry no player listeners: a click on one is forwarded to the real
       row at the same index, so every play button still works. The copy is
       aria-hidden so a screen reader only ever hears the tracklist once. */
  (function () {
    var box = root.querySelector('.pnah-tracklist');
    if (!box) return;
    var track = null, raf = null, hover = false, off = 0, vel = 0;

    function mountEl() { return box.querySelector('#pn-tracklist-mount'); }

    /* (re)build the drift track: pn-mode.js moves the real mount between the
       two panels, so this has to be able to run again after a mode switch */
    function build() {
      var mount = mountEl();
      if (!mount || !mount.children.length) return false;
      if (!track || track.parentNode !== box) {
        track = document.createElement('div');
        track.className = 'pnah-tl-track';
        box.appendChild(track);
        bindClones();
      }
      if (mount.parentNode !== track) track.insertBefore(mount, track.firstChild);
      var old = track.querySelector('[data-pn-tl-clone]');
      if (old) track.removeChild(old);
      var copy = mount.cloneNode(true);
      copy.removeAttribute('id');
      copy.setAttribute('data-pn-tl-clone', '');
      copy.setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(copy.querySelectorAll('[id]'), function (n) { n.removeAttribute('id'); });
      track.appendChild(copy);
      return true;
    }

    function bindClones() {
      track.addEventListener('click', function (e) {
        var copy = e.target.closest && e.target.closest('[data-pn-tl-clone]');
        if (!copy) return;                       /* a real row handles itself */
        /* Map the clone back to the real row by the play trigger's ORDINAL,
           not by child index. The mount holds a single .pn-tracklist wrapper
           rather than the rows themselves, so walking up to a child of `copy`
           always landed on that one wrapper: idx was 0 every time and
           `real.querySelector(...)` returned the first trigger, so every click
           on the duplicated half played track 1. Whether a click worked
           therefore depended on where the drift had carried the seam - which
           is why some tracks played at some scroll positions and not others.
           Counting triggers also drops the SIDE A/B headers out of the
           numbering on its own, since a header carries no trigger. */
        var t = e.target.closest && e.target.closest('.pn-track-trigger');
        if (!t && isMobile()) return;
        /* Rue, 2026-09-07: "you should only make it possible to play the track
           by precisely clicking on the play/pause button, not the whole row."

           The walk-up below maps a click ANYWHERE in a duplicated row onto
           that row's play button, which is how the wide canvas has always let
           you click a row to play it. On mobile that fights the list: the row
           is also the tap target that advances the window one line, so a tap
           on the middle of a cloned row both started the audio and moved the
           list. Below 780px only a direct hit on the control plays; the rest
           of the row belongs to the list. */
        if (!t) {
          var node = e.target;
          while (node && node !== copy &&
                 !(node.querySelector && node.querySelector('.pn-track-trigger'))) {
            node = node.parentNode;
          }
          t = (node && node !== copy) ? node.querySelector('.pn-track-trigger') : null;
        }
        if (!t) return;
        var idx = Array.prototype.indexOf.call(copy.querySelectorAll('.pn-track-trigger'), t);
        var mount = mountEl();
        var real = mount && mount.querySelectorAll('.pn-track-trigger')[idx];
        if (idx < 0 || !real) return;
        e.preventDefault(); e.stopPropagation();
        real.click();
      }, true);
    }

    /* A wheel notch is not a pixel count. Chrome reports pixels (deltaMode 0),
       Firefox reports LINES (deltaMode 1, deltaY 3) and a page-scroll device
       reports pages - so the old `deltaY * 0.55` moved 55px on one browser and
       1.6px on another, which is the "so hard to scroll" case. Normalise to
       pixels first, then feed a velocity that decays each frame instead of
       jumping the list on the spot: one notch glides ~3 rows and settles. */
    function pxDelta(e) {
      var d = e.deltaY;
      if (e.deltaMode === 1) d *= 16;                       /* lines */
      else if (e.deltaMode === 2) d *= (box.clientHeight || 136);   /* pages */
      return d;
    }

    function step() {
      if (!track && !build()) { raf = requestAnimationFrame(step); return; }
      /* mobile drives this window by tap, not by drift (MOBILE-RULES §10) */
      if (isMobile()) { raf = requestAnimationFrame(step); return; }
      var half = track.scrollHeight / 2;
      if (half > 1) {
        if (vel) {
          off += vel;
          vel *= 0.86;
          if (Math.abs(vel) < 0.05) vel = 0;
        }
        if (!hover && !vel) off -= 0.3;           /* the sheet adds; this subtracts */
        off = ((off % half) + half) % half;
        track.style.transform = 'translateY(-' + off.toFixed(1) + 'px)';
      }
      raf = requestAnimationFrame(step);
    }
    function run() { if (!raf) raf = requestAnimationFrame(step); }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    box.addEventListener('mouseenter', function () { hover = true; });
    box.addEventListener('mouseleave', function () { hover = false; });
    box.addEventListener('wheel', function (e) {
      /* MOBILE-RULES.md: "No touch capture - swiping scrolls the page." The
         mobile layout is reachable with a MOUSE too (a narrowed desktop
         window), and there preventDefault() here would eat the wheel while
         the drift it feeds is switched off - the page would simply refuse to
         scroll over this box. Let the wheel through. */
      if (isMobile()) return;
      e.preventDefault();
      vel += pxDelta(e) * 0.16;
      vel = Math.max(-60, Math.min(60, vel));     /* no runaway on a fast flick */
    }, { passive: false });

    build();
    [400, 1500].forEach(function (ms) { setTimeout(build, ms); });   /* the player fills the mount late */
    if (active()) run();
    window.addEventListener('pn:mode', function () {
      if (active()) { setTimeout(function () { build(); run(); }, 30); } else stop();
    });
  })();

  /* ---------- record sheet: slow drift, hover pauses, wheel scrubs, wrap ---------- */
  (function () {
    var win = root.querySelector('.pnah-sheet-win'), track = root.querySelector('.pnah-sheet-track');
    if (!win || !track) return;
    var off = 0, hover = false, raf = null;
    function step() {
      if (isMobile()) { raf = requestAnimationFrame(step); return; }   /* tap-driven */
      var half = track.scrollHeight / 2;
      if (!hover) off += 0.35;
      if (half > 0) off = ((off % half) + half) % half;
      track.style.transform = 'translateY(-' + off.toFixed(1) + 'px)';
      raf = requestAnimationFrame(step);
    }
    win.addEventListener('mouseenter', function () { hover = true; });
    win.addEventListener('mouseleave', function () { hover = false; });
    win.addEventListener('wheel', function (e) {
      if (isMobile()) return;              /* see the tracklist's wheel guard */
      e.preventDefault(); off += e.deltaY * 0.55;
    }, { passive: false });
    function run() { if (raf) return; raf = requestAnimationFrame(step); }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
    if (active()) run();
    window.addEventListener('pn:mode', function () { if (active()) run(); else stop(); });
  })();

  /* ---------- play state: mirror the deck's live region ---------- */
  (function () {
    var label = root.querySelector('.pnah-now-track');
    var stop = root.querySelector('.pnah-now-stop');
    var last = null;
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.pn-track-trigger');
      if (b) last = b;
    }, true);
    function isPlaying() {
      var live = document.querySelector('.pn-tt__live');
      return live ? /playing/i.test(live.textContent || '') : false;
    }
    setInterval(function () {
      if (!active()) return;                    /* not our panel: leave it to the Sticky poller */
      var on = isPlaying();
      root.classList.toggle('is-playing', on);
      if (on && label) {
        var txt = last ? ((last.dataset.side ? last.dataset.side + '. ' : '') + (last.dataset.title || '')) : '';
        if (!txt) { var t1 = document.querySelector('.pn-tt__t1'); txt = t1 ? t1.textContent.trim() : ''; }
        if (txt) label.textContent = txt;
      }
    }, 500);
    if (stop) stop.addEventListener('click', function () {
      var on = document.querySelector('.pn-track-trigger.is-playing') || last;
      if (on) on.click();
    });
  })();

  /* ============================================================
     Mascot peek + SIMILAR records (v5)
     ============================================================ */
  (function () {
    var mascot = root.querySelector('.pnah-mascot');
    var panel  = root.querySelector('.pnah-sim');
    if (!mascot || !panel) return;
    var colA = panel.querySelector('.pnah-sim-col--a .pnah-sim-track');
    var colB = panel.querySelector('.pnah-sim-col--b .pnah-sim-track');
    var colAWin = panel.querySelector('.pnah-sim-col--a'), colBWin = panel.querySelector('.pnah-sim-col--b');
    var selImg = panel.querySelector('.pnah-sim-sel-img'), selName = panel.querySelector('.pnah-sim-sel-name'),
        selMeta = panel.querySelector('.pnah-sim-sel-meta'), selPrice = panel.querySelector('.pnah-sim-sel-price'),
        selView = panel.querySelector('.pnah-sim-sel-view'), selBack = panel.querySelector('.pnah-sim-sel-back');

    var open = false, recs = [], off = 0, hover = false, raf = null, loaded = false, loading = null;

    /* --- records: rendered server-side by sections/pn-similar via the Section
           Rendering API, which can read the BPM metafield. Loaded as soon as
           this mode is active so the first open is never an empty frame. --- */
    /* Similar records come from the store's own style/genre taxonomy via
       window.PNSimilar, not Shopify's related-products engine - see the
       PNSimilar block at the foot of this file for why. */
    function load() {
      if (loaded) return Promise.resolve(recs);
      if (loading) return loading;
      loading = window.PNSimilar.load(10)
        .then(function (list) { recs = list || []; loaded = true; })
        .catch(function (err) {                 /* leave `loaded` false so the next open retries */
          recs = [];
          if (window.console && console.warn) console.warn('[pn] similar records:', err && err.message);
        })
        .then(function () { loading = null; render(); return recs; });
      return loading;
    }

    function row(rec, i, side, tabbable) {
      var d = document.createElement('div');
      d.className = 'pnah-sim-row pnah-sim-row--' + side;
      d.setAttribute('data-idx', String(i));
      d.setAttribute('role', 'button');
      d.tabIndex = tabbable ? 0 : -1;             /* the wrap copy is not a second tab stop */
      var img = document.createElement('img'); img.src = rec.img || ''; img.alt = '';
      if (!rec.img) img.style.visibility = 'hidden';
      var txt = document.createElement('span'); txt.className = 'pnah-sim-txt';
      var artistTxt = rec.artist || rec.name || '';
      var titleTxt  = rec.artist ? (rec.title || '') : '';   /* no artist: the name already carries the whole title */
      var a = document.createElement('span'); a.className = 'pnah-sim-artist'; a.textContent = artistTxt;
      txt.appendChild(a);
      if (titleTxt) { var t = document.createElement('span'); t.className = 'pnah-sim-title'; t.textContent = titleTxt; txt.appendChild(t); }
      var p = document.createElement('span'); p.className = 'pnah-sim-price';  p.textContent = rec.price || '';
      txt.appendChild(p);
      if (side === 'a') { d.appendChild(txt); d.appendChild(img); } else { d.appendChild(img); d.appendChild(txt); }
      d.addEventListener('click', function (e) { e.stopPropagation(); pick(i); });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); pick(i); }
      });
      return d;
    }
    function fill(track, win, set, offset, side) {
      track.innerHTML = '';
      if (!set.length) return;
      /* two copies make the wrap seamless — but only if one copy is at least
         as tall as the window; a short column gets more copies until it is */
      var copies = 0, need = 2 * Math.max(win.clientHeight || 112, 112);
      do {
        set.forEach(function (r, k) { track.appendChild(row(r, offset + k, side, copies === 0)); });
        copies++;
      } while (track.scrollHeight < need && copies < 8);
    }
    function render() {
      if (!recs.length) {
        colA.innerHTML = ''; colB.innerHTML = '';
        var empty = document.createElement('div');
        empty.className = 'pnah-sim-row pnah-sim-row--a'; empty.style.cursor = 'default';
        var s = document.createElement('span'); s.className = 'pnah-sim-artist'; s.textContent = 'Nothing similar yet';
        empty.appendChild(s); colA.appendChild(empty);
        return;
      }
      var half = Math.ceil(recs.length / 2);
      fill(colA, colAWin, recs.slice(0, half), 0, 'a');
      fill(colB, colBWin, recs.slice(half), half, 'b');
    }

    /* --- drift: A down the page, B up, 0.3px per frame; hover pauses ---

       On MOBILE the two columns are real scroll containers, not
       transform-driven tracks. MOBILE-RULES.md gives them the design file's
       `.pnm-scroll` treatment - overflow-y:auto, no scrollbar,
       overscroll-behavior:contain - so a finger can drag the list directly.
       That only works if the drift moves scrollTop; a transform would fight
       the touch scroll and snap back the moment the finger lifted. The
       tracklist, record sheet and description are deliberately NOT like this:
       they stay overflow:hidden and move only when tapped. */
    function driftScroll(win, track, dir) {
      if (!win || !track) return;
      if (track.style.transform) track.style.transform = '';   /* left by the wide canvas */
      var half = track.scrollHeight / 2;
      if (!(half > 1) || half <= win.clientHeight) return;
      var t = win.scrollTop + dir * 0.35;
      if (t >= half) t -= half; else if (t < 0) t += half;
      win.scrollTop = t;
    }
    function step() {
      if (!open) { raf = null; return; }
      if (isMobile()) {
        /* paused means paused: do not touch scrollTop at all while a finger
           is on the column, or the drift would drag against it */
        if (!hover) { driftScroll(colAWin, colA, 1); driftScroll(colBWin, colB, -1); }
        raf = requestAnimationFrame(step);
        return;
      }
      if (!hover) off += 0.3;
      var ha = colA.scrollHeight / 2, hb = colB.scrollHeight / 2;
      if (ha > 0) { var oa = ((off % ha) + ha) % ha; colA.style.transform = 'translateY(-' + oa.toFixed(1) + 'px)'; }
      if (hb > 0) { var ob = ((off % hb) + hb) % hb; colB.style.transform = 'translateY(-' + (hb - ob).toFixed(1) + 'px)'; }
      raf = requestAnimationFrame(step);
    }
    function run()  { if (open && recs.length && !raf) raf = requestAnimationFrame(step); }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
    panel.addEventListener('mouseenter', function () { hover = true; });
    panel.addEventListener('mouseleave', function () { hover = false; });
    /* preventDefault only — the design's handler does not stop propagation */
    panel.addEventListener('wheel', function (e) {
      if (isMobile()) return;              /* see the tracklist's wheel guard */
      e.preventDefault(); off += e.deltaY * 0.5;
    }, { passive: false });

    /* --- open / close / pick --- */
    function setOpen(v) {
      open = !!v;
      root.classList.toggle('sim-open', open);
      document.documentElement.classList.toggle('pn-sim-open', open);   /* lets the fixed mode picker step aside */
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      mascot.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { mascot.classList.remove('is-out'); load().then(function () { if (open) run(); }); }
      else { stop(); hover = false; root.classList.remove('sim-sel'); }
    }
    function pick(i) {
      var r = recs[i]; if (!r) return;
      selImg.src = r.img || ''; selImg.style.visibility = r.img ? '' : 'hidden';
      selName.textContent = r.name || ((r.artist || '') + ' — ' + (r.title || ''));
      selMeta.textContent = (r.label || '') + (r.bpm ? ' · ' + r.bpm + ' BPM' : '');
      selPrice.textContent = r.price || ''; selView.href = r.href || '#';
      root.classList.add('sim-sel');
      setTimeout(function () { try { selView.focus(); } catch (e) {} }, 560);
    }
    /* The mobile ✕ is appended inside the panel, so the outside-click handler
       above returns early for it and it has to close the panel itself. */
    root.pnahSimClose = function () { setOpen(false); };
    root.pnahSimHold = function (ms) {
      try {
        panel.dispatchEvent(new MouseEvent('mouseenter'));
        clearTimeout(root._simHold);
        root._simHold = setTimeout(function () { panel.dispatchEvent(new MouseEvent('mouseleave')); }, ms);
      } catch (e) {}
    };
    selBack.addEventListener('click', function (e) { e.stopPropagation(); root.classList.remove('sim-sel'); });
    mascot.addEventListener('click', function (e) { e.stopPropagation(); setOpen(!open); });
    mascot.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); setOpen(!open); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) setOpen(false); });
    /* click anywhere outside the mascot or the panel closes it */
    document.addEventListener('click', function (e) {
      if (!open) return;
      if (e.target && e.target.closest && e.target.closest('[data-pn-sim]')) return;
      setOpen(false);
    }, true);

    /* --- peek cycle: out ~4.2s, hidden ~2.3s, on a 6.5s loop; first peek at 0.6s.
           No hover-hold: the design's shipped markup binds none. --- */
    var peekTimer = null, hideTimer = null, firstTimer = null;
    function peekOut() {
      if (open || !active()) return;
      mascot.classList.add('is-out');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { mascot.classList.remove('is-out'); }, 4200);
    }
    function startPeeking() {
      stopPeeking();
      load();                                   /* warm the records before the first open */
      firstTimer = setTimeout(peekOut, 600);
      peekTimer = setInterval(peekOut, 6500);
    }
    function stopPeeking() {
      clearInterval(peekTimer); clearTimeout(hideTimer); clearTimeout(firstTimer);
      peekTimer = null; hideTimer = null; firstTimer = null;
      mascot.classList.remove('is-out');
    }
    if (active()) startPeeking();
    window.addEventListener('pn:mode', function () {
      if (active()) startPeeking(); else { stopPeeking(); setOpen(false); }
    });
  })();


  /* ============================================================
     MOBILE (< 700px) — MOBILE-RULES.md.

     Everything here is inert on the two desktop canvases: the builders run
     once, on the first switch into the mobile layout, and every handler
     starts with an isMobile() guard.
     ============================================================ */

  /* ---------- carved artist name, over two lines ---------- */
  /* The wide canvas sets a long name SMALLER on one line (fitSvg). In a 354px
     column that would drop "Sussan Deyhim & Richard Horowitz" to about 19px,
     so the design breaks it over two lines at 27px instead. Split at the word
     boundary nearest the middle, measuring rather than counting characters,
     so the two lines come out close to the same width. */
  function fitMobile() {
    var svg = root.querySelector('.pnah-carve--artist');
    if (!svg) return;
    var t = svg.querySelector('text'); if (!t) return;
    var full = (svg.getAttribute('data-text') || t.textContent || '').trim();
    if (!full) return;
    var maxW = stage ? (stage.clientWidth - 36) : 340;
    if (maxW <= 0) return;

    /* clear any second line from an earlier pass */
    var extra = svg.querySelectorAll('text.pnah-l2');
    Array.prototype.forEach.call(extra, function (n) { n.parentNode.removeChild(n); });
    t.removeAttribute('textLength'); t.removeAttribute('lengthAdjust');
    t.classList.remove('pnah-l1');

    var FS = 27, MIN = 17, LH = 26;
    function widthAt(str, fs) {
      t.textContent = str; t.style.fontSize = fs + 'px';
      try { return t.getComputedTextLength(); } catch (e) { return 0; }
    }
    t.setAttribute('y', '24');
    if (widthAt(full, FS) <= maxW) {                    /* fits on one line */
      var w1 = widthAt(full, FS);
      svg.setAttribute('height', '36');
      svg.setAttribute('viewBox', '0 0 ' + Math.ceil(w1 + 6) + ' 36');
      svg.setAttribute('width', String(Math.ceil(w1 + 6)));
      return;
    }
    /* two lines: try every word break, keep the one whose halves are closest */
    var words = full.split(/\s+/), best = null;
    for (var i = 1; i < words.length; i++) {
      var a = words.slice(0, i).join(' '), b = words.slice(i).join(' ');
      var wa = widthAt(a, FS), wb = widthAt(b, FS);
      var score = Math.max(wa, wb);
      if (best === null || score < best.score) best = { a: a, b: b, score: score };
    }
    if (!best) { best = { a: full, b: '', score: widthAt(full, FS) }; }
    /* still too wide at 27px? step the size down until the longer half fits */
    var fs = FS;
    while (best.score > maxW && fs > MIN) {
      fs -= 1;
      best.score = Math.max(widthAt(best.a, fs), widthAt(best.b, fs));
    }
    var lh = Math.round(LH * fs / FS);
    t.textContent = best.a; t.style.fontSize = fs + 'px'; t.setAttribute('y', String(fs - 3));
    if (best.b) {
      var l2 = t.cloneNode(false);
      l2.setAttribute('class', 'pnah-l2');
      l2.setAttribute('y', String(fs - 3 + lh));
      l2.textContent = best.b;
      l2.style.fontSize = fs + 'px';
      t.parentNode.appendChild(l2);
    }
    var h = best.b ? (fs + lh) : (fs + 6);
    var w = Math.ceil(best.score + 6);
    svg.setAttribute('height', String(h));
    svg.setAttribute('width', String(w));
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
  }

  /* ---------- one-time mobile scaffolding ---------- */
  var mobileBuilt = false;
  function buildMobile() {
    if (mobileBuilt) return;
    mobileBuilt = true;

    /* 1. description -> a window of sentence rows, doubled so it wraps.
          Split WITHOUT a lookbehind: `(?<=[.!?])\s+` throws a SyntaxError on
          iOS Safari before 16.4, which would take the whole file down on
          exactly the browser this layout is for. */
    (function () {
      var pEl = root.querySelector('.pnah-desc'); if (!pEl) return;
      var txt = (pEl.textContent || '').replace(/\s+/g, ' ').trim();
      if (!txt) return;
      var parts = [], buf = '';
      for (var i = 0; i < txt.length; i++) {
        buf += txt.charAt(i);
        if ('.!?'.indexOf(txt.charAt(i)) > -1 && (i + 1 >= txt.length || /\s/.test(txt.charAt(i + 1)))) {
          if (buf.trim()) parts.push(buf.trim());
          buf = '';
        }
      }
      if (buf.trim()) parts.push(buf.trim());
      if (!parts.length) parts = [txt];
      var track = document.createElement('span');
      track.className = 'pnah-mtrack';
      function fill(hidden) {
        parts.forEach(function (line) {
          var el = document.createElement('span');
          el.className = 'pnah-mline';
          el.textContent = line;
          if (hidden) el.setAttribute('aria-hidden', 'true');
          track.appendChild(el);
        });
      }
      fill(false);
      fill(true);            /* the wrap copy — hidden from assistive tech and
                                built here in the browser, never in the HTML,
                                so the crawler still reads the text once */
      pEl.textContent = '';
      pEl.appendChild(track);
    })();

    /* 2. "TAP TO SEE MORE" opposite the BPM caption */
    (function () {
      var head = root.querySelector('.pnah-tracks-head'); if (!head) return;
      if (head.querySelector('.pnah-mhint')) return;
      var h = document.createElement('span');
      h.className = 'pnah-mhint';
      h.textContent = 'Tap to see more';
      head.insertBefore(h, head.firstChild);
    })();

    /* 3. plain price for the dark bar (the carved wood fill is invisible on it) */
    (function () {
      var row = root.querySelector('.pnah-pricerow'); if (!row) return;
      if (row.querySelector('.pnah-mprice')) return;
      var svg = row.querySelector('.pnah-carve--price');
      var money = svg ? (svg.getAttribute('data-text') || '') : '';
      if (!money) return;
      var el = document.createElement('span');
      el.className = 'pnah-mprice';
      if (root.querySelector('.pnah-stock--sold')) {
        var st = document.createElement('s'); st.textContent = money; el.appendChild(st);
      } else {
        el.textContent = money;
      }
      row.insertBefore(el, row.firstChild);
    })();

    /* 4. the SIMILAR panel's close ✕ — 44px, off the panel's top-left corner */
    (function () {
      var panel = root.querySelector('.pnah-sim'); if (!panel) return;
      if (panel.parentNode.querySelector('.pnah-mclose')) return;
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'pnah-mclose';
      x.setAttribute('aria-label', 'Close similar records');
      x.textContent = '✕';
      x.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (root.pnahSimClose) root.pnahSimClose();
      });
      panel.appendChild(x);
    })();

    /* 5. a touch on a SIMILAR column pauses its drift, resuming 2.5s after
          release. The drift already pauses on mouseenter, so rather than
          reach into it we hand it the events it is already listening for. */
    (function () {
      var panel = root.querySelector('.pnah-sim'); if (!panel) return;
      panel.addEventListener('touchstart', function () {
        if (isMobile() && root.pnahSimHold) root.pnahSimHold(60000);
      }, { passive: true });
      panel.addEventListener('touchend', function () {
        if (isMobile() && root.pnahSimHold) root.pnahSimHold(2500);
      }, { passive: true });
    })();
  }

  /* ---------- tap advances a window by one row ---------- */
  /* The three windows are driven by translateY on a doubled track, the same
     mechanism the wide canvas drifts. A tap animates to the next row boundary
     and, once past the halfway seam, jumps back by half a track with the
     transition off — so the list wraps without ever reaching an end.

     Row offsets are measured against the TRACK's own rect, not offsetTop:
     offsetTop resolves to the nearest positioned ancestor, which here is the
     panel, and every row would report the same number. */
  (function () {
    var WINS = [
      { win: '.pnah-desc',      track: '.pnah-mtrack',      rows: '.pnah-mline' },
      { win: '.pnah-tracklist', track: '.pnah-tl-track',    rows: '.pn-tracklist-item, .pn-sheet-side' },
      { win: '.pnah-sheet-win', track: '.pnah-sheet-track', rows: '.pnah-row' }
    ];
    var off = {};

    function advance(cfg) {
      var win = root.querySelector(cfg.win); if (!win) return;
      var track = win.querySelector(cfg.track) || root.querySelector(cfg.track);
      if (!track) return;
      var half = track.scrollHeight / 2;
      if (!(half > 1) || half <= win.clientHeight) return;

      var top = track.getBoundingClientRect().top;
      var rows = track.querySelectorAll(cfg.rows);
      var cur = off[cfg.win] || 0, next = null;
      for (var i = 0; i < rows.length; i++) {
        var y = rows[i].getBoundingClientRect().top - top;   /* layout offset:
             the transform moves row and track together, so this is unaffected
             by how far the window is already scrolled */
        if (y > cur + 1) { next = y; break; }
      }
      if (next == null) return;
      /* A "row" in the description is a whole sentence, and a long one is
         taller than the 85px window: stepping straight to the next sentence
         would scroll its last lines past unread. Never advance by more than
         one windowful - the remainder of that row is shown first, and the
         next tap moves on. */
      if (next - cur > win.clientHeight) next = cur + win.clientHeight;

      track.style.transition = 'transform .38s cubic-bezier(.22,1,.36,1)';
      track.style.transform = 'translateY(-' + next.toFixed(1) + 'px)';
      off[cfg.win] = next;

      if (next >= half) {
        setTimeout(function () {
          var back = off[cfg.win] - half;
          track.style.transition = 'none';
          track.style.transform = 'translateY(-' + back.toFixed(1) + 'px)';
          void track.offsetHeight;                       /* commit before restoring */
          track.style.transition = '';
          off[cfg.win] = back;
        }, 400);
      }
    }

    root.addEventListener('click', function (e) {
      if (!isMobile()) return;
      /* the play control is its own tap target and must not also advance the
         list; links and the add button keep their own jobs too */
      if (e.target.closest && e.target.closest('.pn-track-trigger, a, button')) return;
      for (var i = 0; i < WINS.length; i++) {
        if (e.target.closest && e.target.closest(WINS[i].win)) { advance(WINS[i]); return; }
      }
    });
  })();

  /* ---------- add to cart ---------- */
  (function () {
    var form = root.querySelector('.pnah-form'), btn = root.querySelector('.pnah-add');
    if (!form || !btn) return;
    var span = btn.querySelector('span'), busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || btn.disabled) return;
      busy = true;
      var original = span ? span.textContent : '';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () { if (span) span.textContent = 'Added ✓'; document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
        .catch(function () { if (span) span.textContent = 'Try again'; })
        .then(function () { setTimeout(function () { if (span) span.textContent = original; busy = false; }, 1600); });
    });
  })();
})();

/* ============================================================
   window.PNSimilar — where "similar records" comes from.

   NOT Shopify's recommendation engine. `/recommendations/products` with
   intent=related ranks on order history and product type, which on a
   one-copy vinyl catalogue put a hard rock record next to a techno 12".
   This asks the store's OWN taxonomy instead: the page already renders
   filter links built from each record's style/genre metafields, e.g.
       /collections/all?filter.p.m.custom.style=Tech+House
   so we request sections/pn-similar.liquid on those URLs — every candidate
   already shares the tag — then rank by how many style tags overlap.

   Defined by whichever of pn-sticky.js / pn-afterhours.js runs first.
   ============================================================ */
if (!window.PNSimilar) window.PNSimilar = (function () {
  'use strict';
  var cache = null, pending = null;

  function paramValue(href, key) {
    var m = String(href).match(new RegExp('[?&]' + key + '=([^&#]*)'));
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }
  function uniq(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
  function asList(v) {
    if (!v) return [];
    if (Array.isArray(v)) return v.map(String);
    return String(v).split(/\s*,\s*/).filter(Boolean);
  }
  function currentHandle() {
    var seg = location.pathname.split('/').filter(Boolean);
    var i = seg.indexOf('products');
    return i >= 0 && seg[i + 1] ? seg[i + 1] : '';
  }

  /* the record's own tags, read off the filter links the page already renders */
  function myTags() {
    var styleUrls = [], genreUrl = '';
    Array.prototype.forEach.call(
      document.querySelectorAll('a[href*="filter.p.m.custom.style="]'),
      function (a) { var h = a.getAttribute('href'); if (h && styleUrls.indexOf(h) < 0) styleUrls.push(h); });
    var g = document.querySelector('a[href*="filter.p.m.custom.genre="]');
    if (g) genreUrl = g.getAttribute('href') || '';
    return {
      styleUrls: styleUrls,
      genreUrl: genreUrl,
      styles: uniq(styleUrls.map(function (u) { return paramValue(u, 'filter\\.p\\.m\\.custom\\.style'); }).filter(Boolean)),
      genre: genreUrl ? paramValue(genreUrl, 'filter\\.p\\.m\\.custom\\.genre') : ''
    };
  }

  function fetchSection(url) {
    var u = url + (url.indexOf('?') < 0 ? '?' : '&') + 'section_id=pn-similar';
    return fetch(u, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var tag = d.querySelector('script[data-pn-similar]');
        return tag ? JSON.parse(tag.textContent || '[]') : [];
      })
      .catch(function (e) { console.warn('[pn-similar] ' + url + ' failed', e); return []; });
  }

  /* Ask each of the record's own styles in turn (most specific first), then
     the genre, until there are enough candidates. */
  function load(want) {
    want = want || 10;
    if (cache) return Promise.resolve(cache);
    if (pending) return pending;
    var tags = myTags(), mine = currentHandle();
    var urls = tags.styleUrls.slice(0, 3);
    if (tags.genreUrl) urls.push(tags.genreUrl);
    if (!urls.length) urls = ['/recommendations/products?product_id=&limit=10&intent=related'];

    var seen = {}, out = [];
    pending = urls.reduce(function (chain, url) {
      return chain.then(function () {
        if (out.length >= want) return;
        return fetchSection(url).then(function (list) {
          list.forEach(function (rec) {
            if (!rec || !rec.handle || rec.handle === mine || seen[rec.handle]) return;
            seen[rec.handle] = 1;
            var st = asList(rec.style);
            rec._score = st.filter(function (x) { return tags.styles.indexOf(x) >= 0; }).length;
            if (rec.genre && tags.genre && String(rec.genre) === tags.genre) rec._score += 0.5;
            out.push(rec);
          });
        });
      });
    }, Promise.resolve()).then(function () {
      out.sort(function (a, b) { return b._score - a._score; });
      cache = out.slice(0, want);
      pending = null;
      return cache;
    });
    return pending;
  }
  return { load: load, tags: myTags };
})();
